import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import SettlementsTypes from '../types/SettlementsType';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  allSettlements: { ...initialStateList },
  settlementsHistory: { ...initialStateList },
  balance: {
    availableBalance: null,
    currency: '',
  },
  banks: [],
};

export const Settlements = handleActions(
  {
    ...GridFilters,
    [SettlementsTypes.actions.fetchSettlementsBalancesSuccess]: (state, { payload: { balance, banks } }) => ({
      ...state,
      balance,
      banks,
    }),
  },
  initialState
);

const getSettlements = (state) => state.Settlements;

export const getSettlementsList = (state, list) => {
  const settlements = getSettlements(state);
  return settlements[list] || undefined;
};

export const getAvailableBalance = createSelector(getSettlements, (state) => state.balance);
export const getBanks = createSelector(getSettlements, (state) => state.banks);
